import { h, JSX } from '@stencil/core';

// TODO PB2B-13987: update the interface
// this can be done once the ui-icon is deprecated
export interface valueChainPoint {
  id?: number;
  icon: string;
  headline: string;
  text: string;
}

type Layout = 'small' | 'large';

type Coordinates = {
  x: number;
  y: number;
};

type IconCoordinates = {
  small: Coordinates[];
  large: {
    [key: number]: Coordinates[];
  };
};

const iconSize = {
  small: '16px',
  large: '40px',
};

const iconCoordinates: IconCoordinates = {
  // y coordinates increase by 79px
  small: [
    { x: 33, y: 32 },
    { x: 33, y: 111 },
    { x: 33, y: 190 },
    { x: 33, y: 269 },
    { x: 33, y: 348 },
    { x: 33, y: 427 },
  ],
  // no y coordinates pattern because of inconsistent spacing
  large: {
    3: [
      { x: 179, y: 139 },
      { x: 559, y: 86 },
      { x: 940, y: 139 },
    ],
    4: [
      { x: 130, y: 139 },
      { x: 417, y: 86 },
      { x: 702, y: 139 },
      { x: 988, y: 86 },
    ],
    5: [
      { x: 95, y: 139 },
      { x: 323, y: 86 },
      { x: 552, y: 139 },
      { x: 780, y: 86 },
      { x: 1005, y: 139 },
    ],
    6: [
      { x: 83, y: 139 },
      { x: 270, y: 86 },
      { x: 461, y: 139 },
      { x: 648, y: 86 },
      { x: 840, y: 139 },
      { x: 1026, y: 86 },
    ],
  },
};

export function fetchIcons(steps: valueChainPoint[]): Promise<string[]> {
  return Promise.all(
    steps.map(async (step) => {
      const icon = await window.ui.services.svg.fetchSvg(step.icon, 'content');
      return icon;
    })
  );
}

function addCoordinatesToIcons(icons: string[], layout: Layout): string[] {
  const size = iconSize[layout];
  const coordinates =
    layout === 'small' ? iconCoordinates.small.slice(0, icons.length) : iconCoordinates.large[icons.length];

  const parser = new DOMParser();
  const serializer = new XMLSerializer();

  return icons.map((svg, index) => {
    const { x, y } = coordinates[index];

    // Parse the SVG string as a DOM element
    const svgElement = parser.parseFromString(svg, 'image/svg+xml').documentElement;
    svgElement.setAttribute('x', x.toString());
    svgElement.setAttribute('y', y.toString());
    svgElement.setAttribute('width', size);
    svgElement.setAttribute('height', size);

    // Serialize the modified SVG back to a string
    return serializer.serializeToString(svgElement);
  });
}

function threePointInfographic(icons: string[], layout: Layout): string {
  return {
    small: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" height="242" viewBox="0 0 121 242" aria-hidden="true">
        <defs>
          <mask id="mask" maskUnits="userSpaceOnUse">
            <path
              class="lineMask"
              stroke="#00358e"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="2"
              stroke-dashoffset="395.10"
              stroke-dasharray="395.10"
              d="M40.5 2.15044C40.5 2.15044 49.5 1.59044 56.63 2.59044C74.12 6.64044 87.16 22.3204 87.16 41.0504C87.16 62.8504 71.49 81.5204 49.69 81.5204L38.47 81.4904C16.67 81.4904 1 99.1604 1 120.96C1 142.76 16.67 160.44 38.47 160.45H49.69C71.49 160.45 87.16 177.12 87.16 198.92C87.16 220.72 71.49 238.39 49.69 238.39"
            />
          </mask>
        </defs>
        <g transform="matrix(0 -1 -1 0 121 52.45)">
          <circle class="pointCircle pointCircle--1" cx="12" cy="12" r="12" fill="#00358e" />
        </g>
        <path class="linePoint linePoint--1" stroke="#00358e" stroke-width="2" d="M97 40.45H57" />
        <path
          class="pointNumber pointNumber--1"
          fill="#fff"
          d="M110.382 36.073v8.376h-1.704v-4.38c0-.708.024-1.848.048-2.292h-.024a15.46 15.46 0 0 1-1.02.876l-.432.348-.828-1.128 2.436-1.8h1.524Z"
        />
        <circle class="iconCircle iconCircle--1" cx="41" cy="40.449" r="16" fill="#fff" />
        <g transform="matrix(0 -1 -1 0 121 131.449)">
          <circle class="pointCircle pointCircle--2" cx="12" cy="12" r="12" fill="#00358e" />
        </g>
        <path class="linePoint linePoint--2" stroke="#00358e" stroke-width="2" d="M97 119.449H57" />
        <path
          class="pointNumber pointNumber--2"
          fill="#fff"
          d="m106.41 116.813-.168-1.392c.672-.312 1.572-.492 2.496-.492 1.548 0 2.868.78 2.868 2.424 0 1.056-.492 2.004-2.04 3.456a13.055 13.055 0 0 1-1.668 1.344v.024c.756-.024 1.74-.036 2.484-.036h1.404v1.308h-5.712v-1.392c2.688-2.184 3.768-3.324 3.768-4.524 0-.912-.66-1.284-1.5-1.284-.612 0-1.26.18-1.932.564Z"
        />
        <circle class="iconCircle iconCircle--2" cx="41" cy="119.449" r="16" fill="#fff" />
        <g transform="matrix(0 -1 -1 0 121 210.449)">
          <circle class="pointCircle pointCircle--3" cx="12" cy="12" r="12" fill="#00358e" />
        </g>
        <path class="linePoint linePoint--3" stroke="#00358e" stroke-width="2" d="M97 198.449H57" />
        <path
          class="pointNumber pointNumber--3"
          fill="#fff"
          d="M107.754 198.753a5.5 5.5 0 0 0-.42.012v-1.248c.132.012.276.024.408.024 1.416 0 2.22-.372 2.22-1.2 0-.744-.648-1.152-1.608-1.152-.672 0-1.344.144-1.932.42l-.108-1.32c.696-.264 1.536-.36 2.28-.36 1.884 0 3.024.816 3.024 2.184 0 1.116-.792 1.788-1.992 1.944v.036c1.26.132 2.1.912 2.1 2.052 0 1.512-1.428 2.448-3.456 2.448a7.306 7.306 0 0 1-2.196-.312l.084-1.404c.732.288 1.38.432 2.028.432 1.056 0 1.836-.384 1.836-1.284s-.828-1.272-2.268-1.272Z"
        />
        <circle class="iconCircle iconCircle--3" cx="41" cy="198.449" r="16" fill="#fff" />
        <path
          mask="url(#mask)"
          class="line"
          stroke="#00358e"
          stroke-dasharray="8 8"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-width="2"
          stroke-dashoffset="395.10"
          d="M40.5 2.15044C40.5 2.15044 49.5 1.59044 56.63 2.59044C74.12 6.64044 87.16 22.3204 87.16 41.0504C87.16 62.8504 71.49 81.5204 49.69 81.5204L38.47 81.4904C16.67 81.4904 1 99.1604 1 120.96C1 142.76 16.67 160.44 38.47 160.45H49.69C71.49 160.45 87.16 177.12 87.16 198.92C87.16 220.72 71.49 238.39 49.69 238.39"
        />
        <path class="lineEnd" d="M44.0801 238.4L49.3301 241.43V235.37L44.0801 238.4Z" fill="#00358e"/>
        <path class="lineStart" d="M38.6599 4C39.7645 4 40.6599 3.10457 40.6599 2C40.6599 0.89543 39.7645 0 38.6599 0C37.5553 0 36.6599 0.89543 36.6599 2C36.6599 3.10457 37.5553 4 38.6599 4Z" fill="#00358e"/>
        ${renderIcons(icons, layout)}
      </svg>`,
    large: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 1146 266" aria-hidden="true">
        <defs>
          <mask id="mask" maskUnits="userSpaceOnUse">
            <path
              class="lineMask"
              stroke="#00358e"
              stroke-linecap="round"
              stroke-miterlimit="6.7"
              stroke-width="2"
              stroke-dashoffset="1496.29"
              stroke-dasharray="1496.29"
              d="M4.02738 133.97C4.02738 140.97 3.78754 148.03 4.7469 154.99C10.8828 199.8 48.4379 234.72 98.9644 236.96H289.118C343.412 235.43 383.276 197.72 383.276 146.62L383.186 125.34C383.186 74.84 425.638 33.59 479.052 31.01H664.409C717.784 33.63 762.194 74.86 762.194 125.34L762.224 146.62C762.224 197.54 807.374 235.23 861.408 237.01L1043.63 236.99C1097.39 234.97 1140.24 197.36 1140.24 146.62"
            />
          </mask>
        </defs>
        <path class="linePoint linePoint--1" stroke="#00358e" stroke-width="2" d="M199 32v92" />
        <circle class="pointCircle pointCircle--1" cx="199" cy="16" r="16" fill="#00358e" />
        <path
          class="pointNumber pointNumber--1"
          fill="#fff"
          d="M200.842 10.832V22h-2.272v-5.84c0-.944.032-2.464.064-3.056h-.032c-.256.256-.784.704-1.36 1.168l-.576.464-1.104-1.504 3.248-2.4h2.032Z"
        />
        <circle class="iconCircle iconCircle--1" cx="199" cy="160" r="36" fill="#fff" />
        <path class="linePoint linePoint--3" stroke="#00358e" stroke-width="2" d="M959 32v92" />
        <circle class="pointCircle pointCircle--3" cx="959" cy="16" r="16" fill="#00358e" />
        <path
          class="pointNumber pointNumber--3"
          fill="#fff"
          d="M957.338 17.072c-.128 0-.368 0-.56.016v-1.664a6.2 6.2 0 0 0 .544.032c1.888 0 2.96-.496 2.96-1.6 0-.992-.864-1.536-2.144-1.536-.896 0-1.792.192-2.576.56l-.144-1.76c.928-.352 2.048-.48 3.04-.48 2.512 0 4.032 1.088 4.032 2.912 0 1.488-1.056 2.384-2.656 2.592v.048c1.68.176 2.8 1.216 2.8 2.736 0 2.016-1.904 3.264-4.608 3.264-.976 0-1.952-.112-2.928-.416l.112-1.872c.976.384 1.84.576 2.704.576 1.408 0 2.448-.512 2.448-1.712s-1.104-1.696-3.024-1.696Z"
        />
        <circle class="iconCircle iconCircle--3" cx="959" cy="160" r="36" fill="#fff" />
        <circle class="iconCircle iconCircle--2" cx="579" cy="106" r="36" fill="#fff" />
        <path class="linePoint linePoint--2" stroke="#00358e" stroke-width="2" d="M579 234v-92" />
        <circle class="pointCircle pointCircle--2" cx="579" cy="250" r="16" fill="#00358e" />
        <path
          class="pointNumber pointNumber--2"
          fill="#fff"
          d="m575.546 247.152-.224-1.856c.896-.416 2.096-.656 3.328-.656 2.064 0 3.824 1.04 3.824 3.232 0 1.408-.656 2.672-2.72 4.608-.944.88-1.632 1.392-2.224 1.792v.032c1.008-.032 2.32-.048 3.312-.048h1.872V256h-7.616v-1.856c3.584-2.912 5.024-4.432 5.024-6.032 0-1.216-.88-1.712-2-1.712-.816 0-1.68.24-2.576.752Z"
        />
        <path
          mask="url(#mask)"
          class="line"
          stroke="#00358e"
          stroke-dasharray="11 11"
          stroke-linecap="round"
          stroke-miterlimit="6.7"
          stroke-width="2"
          stroke-dashoffset="1496.29"
          d="M4.02738 133.97C4.02738 140.97 3.78754 148.03 4.7469 154.99C10.8828 199.8 48.4379 234.72 98.9644 236.96H289.118C343.412 235.43 383.276 197.72 383.276 146.62L383.186 125.34C383.186 74.84 425.638 33.59 479.052 31.01H664.409C717.784 33.63 762.194 74.86 762.194 125.34L762.224 146.62C762.224 197.54 807.374 235.23 861.408 237.01L1043.63 236.99C1097.39 234.97 1140.24 197.36 1140.24 146.62"
        />
        <path class="lineStart" d="M3.99735 136C6.20502 136 7.99469 134.209 7.99469 132C7.99469 129.791 6.20502 128 3.99735 128C1.78967 128 0 129.791 0 132C0 134.209 1.78967 136 3.99735 136Z" fill="#00358e"/>
        <path class="lineEnd" d="M1140.24 138L1145 146.25H1135.49L1140.24 138Z" fill="#00358e"/>
        ${renderIcons(icons, layout)}
      </svg>`,
  }[layout];
}

function fourPointInfographic(icons: string[], layout: Layout): string {
  return {
    small: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" height="321" viewBox="0 0 121 321" aria-hidden="true">
        <defs>
          <mask id="mask" maskUnits="userSpaceOnUse">
            <path
              class="lineMask"
              stroke="#00358e"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="2"
              stroke-dashoffset="527.71"
              stroke-dasharray="527.71"
              d="M40.5 1.65044C40.5 1.65044 49.5 1.09044 56.63 2.09044C74.12 6.14044 87.16 21.8204 87.16 40.5504C87.16 62.3504 71.49 81.0204 49.69 81.0204L38.47 80.9904C16.67 80.9904 1 98.6604 1 120.46C1 142.26 16.67 159.94 38.47 159.95H49.69C71.49 159.95 87.16 177.62 87.16 199.42C87.16 221.22 71.49 238.89 49.69 238.89H38.47C16.67 238.89 1 255.56 1 277.36C1 299.16 16.67 316.83 38.47 316.83"
            />
          </mask>
        </defs>
        <g transform="matrix(0 -1 -1 0 121 52.42)">
          <circle class="pointCircle pointCircle--1" cx="12" cy="12" r="12" fill="#00358e" />
        </g>
        <path class="linePoint linePoint--1" stroke="#00358e" stroke-width="2" d="M97 40.42H57" />
        <path
          class="pointNumber pointNumber--1"
          fill="#fff"
          d="M110.382 36.043v8.376h-1.704v-4.38c0-.708.024-1.848.048-2.292h-.024a15.46 15.46 0 0 1-1.02.876l-.432.348-.828-1.128 2.436-1.8h1.524Z"
        />
        <circle class="iconCircle iconCircle--1" cx="41" cy="40.419" r="16" fill="#fff" />
        <g transform="matrix(0 -1 -1 0 121 131.419)">
          <circle class="pointCircle pointCircle--2" cx="12" cy="12" r="12" fill="#00358e" />
        </g>
        <path class="linePoint linePoint--2" stroke="#00358e" stroke-width="2" d="M97 119.419H57" />
        <path
          class="pointNumber pointNumber--2"
          fill="#fff"
          d="m106.41 116.783-.168-1.392c.672-.312 1.572-.492 2.496-.492 1.548 0 2.868.78 2.868 2.424 0 1.056-.492 2.004-2.04 3.456a13.055 13.055 0 0 1-1.668 1.344v.024c.756-.024 1.74-.036 2.484-.036h1.404v1.308h-5.712v-1.392c2.688-2.184 3.768-3.324 3.768-4.524 0-.912-.66-1.284-1.5-1.284-.612 0-1.26.18-1.932.564Z"
        />
        <circle class="iconCircle iconCircle--2" cx="41" cy="119.419" r="16" fill="#fff" />
        <g transform="matrix(0 -1 -1 0 121 210.419)">
          <circle class="pointCircle pointCircle--3" cx="12" cy="12" r="12" fill="#00358e" />
        </g>
        <path class="linePoint linePoint--3" stroke="#00358e" stroke-width="2" d="M97 198.419H57" />
        <path
          class="pointNumber pointNumber--3"
          fill="#fff"
          d="M107.754 198.723a5.5 5.5 0 0 0-.42.012v-1.248c.132.012.276.024.408.024 1.416 0 2.22-.372 2.22-1.2 0-.744-.648-1.152-1.608-1.152-.672 0-1.344.144-1.932.42l-.108-1.32c.696-.264 1.536-.36 2.28-.36 1.884 0 3.024.816 3.024 2.184 0 1.116-.792 1.788-1.992 1.944v.036c1.26.132 2.1.912 2.1 2.052 0 1.512-1.428 2.448-3.456 2.448a7.306 7.306 0 0 1-2.196-.312l.084-1.404c.732.288 1.38.432 2.028.432 1.056 0 1.836-.384 1.836-1.284s-.828-1.272-2.268-1.272Z"
        />
        <circle class="iconCircle iconCircle--3" cx="41" cy="198.419" r="16" fill="#fff" />
        <g transform="matrix(0 -1 -1 0 121 289.419)">
          <circle class="pointCircle pointCircle--4" cx="12" cy="12" r="12" fill="#00358e" />
        </g>
        <path class="linePoint linePoint--4" stroke="#00358e" stroke-width="2" d="M97 277.419H57" />
        <path
          class="pointNumber pointNumber--4"
          fill="#fff"
          d="M111.15 273.043v5.388h1.14v1.272h-1.14v1.716h-1.596v-1.716h-3.876v-1.344l3.432-5.316h2.04Zm-1.56 5.388v-1.416c0-.708.012-1.8.048-2.736h-.024c-.312.612-.9 1.608-1.188 2.064l-1.296 2.088h2.46Z"
        />
        <circle class="iconCircle iconCircle--4" cx="41" cy="277.419" r="16" fill="#fff" />
        <path
          class="line"
          mask="url(#mask)"
          stroke="#00358e"
          stroke-dasharray="8 8"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-width="2"
          stroke-dashoffset="527.71"
          d="M40.5 1.65044C40.5 1.65044 49.5 1.09044 56.63 2.09044C74.12 6.14044 87.16 21.8204 87.16 40.5504C87.16 62.3504 71.49 81.0204 49.69 81.0204L38.47 80.9904C16.67 80.9904 1 98.6604 1 120.46C1 142.26 16.67 159.94 38.47 159.95H49.69C71.49 159.95 87.16 177.62 87.16 199.42C87.16 221.22 71.49 238.89 49.69 238.89H38.47C16.67 238.89 1 255.56 1 277.36C1 299.16 16.67 316.83 38.47 316.83"
        />
        <path class="lineEnd" d="M44.1599 316.5L38.9099 319.53V313.47L44.1599 316.5Z" fill="#00358e"/>
        <path class="lineStart" d="M39.1599 4C40.2645 4 41.1599 3.10457 41.1599 2C41.1599 0.89543 40.2645 0 39.1599 0C38.0553 0 37.1599 0.89543 37.1599 2C37.1599 3.10457 38.0553 4 39.1599 4Z" fill="#00358e"/>
        ${renderIcons(icons, layout)}
      </svg>`,
    large: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 1147 266" aria-hidden="true">
        <defs>
          <mask id="mask" maskUnits="userSpaceOnUse">
            <path
              class="lineMask"
              stroke="#00358e"
              stroke-linecap="round"
              stroke-miterlimit="6.7"
              stroke-width="2"
              stroke-dashoffset="1626.05"
              stroke-dasharray="1626.05"
              d="M4.02848 133.98C4.02848 140.98 3.79857 148.04 4.73823 155C10.7761 199.8 46.7332 234.72 96.4654 236.96H195.63C249.071 235.43 289.266 197.72 289.266 146.63L289.186 125.35C289.186 74.85 331.971 33.61 384.542 31.03H480.038C532.569 33.65 574.314 74.88 574.314 125.35L574.344 146.63C574.344 197.54 616.819 235.23 670 237.01L763.387 236.99C816.298 234.97 858.483 197.36 858.483 146.63V125.35C858.492 74.69 900.547 33.35 953.359 31.01L1046.85 31.06C1099.15 33.92 1140.62 75.04 1140.62 125.35"
            />
          </mask>
        </defs>
        <path class="linePoint linePoint--1" stroke="#00358e" stroke-width="2" d="M150.5 32v92" />
        <circle class="pointCircle pointCircle--1" cx="150.5" cy="16" r="16" fill="#00358e" />
        <path
          class="pointNumber pointNumber--1"
          fill="#fff"
          d="M152.342 10.832V22h-2.272v-5.84c0-.944.032-2.464.064-3.056h-.032c-.256.256-.784.704-1.36 1.168l-.576.464-1.104-1.504 3.248-2.4h2.032Z"
        />
        <circle class="iconCircle iconCircle--1" cx="150.5" cy="160" r="36" fill="#fff" />
        <path class="linePoint linePoint--3" stroke="#00358e" stroke-width="2" d="M722.5 32v92" />
        <circle class="pointCircle pointCircle--3" cx="722.5" cy="16" r="16" fill="#00358e" />
        <path
          class="pointNumber pointNumber--3"
          fill="#fff"
          d="M720.838 17.072c-.128 0-.368 0-.56.016v-1.664a6.2 6.2 0 0 0 .544.032c1.888 0 2.96-.496 2.96-1.6 0-.992-.864-1.536-2.144-1.536-.896 0-1.792.192-2.576.56l-.144-1.76c.928-.352 2.048-.48 3.04-.48 2.512 0 4.032 1.088 4.032 2.912 0 1.488-1.056 2.384-2.656 2.592v.048c1.68.176 2.8 1.216 2.8 2.736 0 2.016-1.904 3.264-4.608 3.264-.976 0-1.952-.112-2.928-.416l.112-1.872c.976.384 1.84.576 2.704.576 1.408 0 2.448-.512 2.448-1.712s-1.104-1.696-3.024-1.696Z"
        />
        <circle class="iconCircle iconCircle--3" cx="722.5" cy="160" r="36" fill="#fff" />
        <circle class="iconCircle iconCircle--2" cx="436.5" cy="106" r="36" fill="#fff" />
        <path class="linePoint linePoint--2" stroke="#00358e" stroke-width="2" d="M436.5 234v-92" />
        <circle class="pointCircle pointCircle--2" cx="436.5" cy="250" r="16" fill="#00358e" />
        <path
          class="pointNumber pointNumber--2"
          fill="#fff"
          d="m433.046 247.152-.224-1.856c.896-.416 2.096-.656 3.328-.656 2.064 0 3.824 1.04 3.824 3.232 0 1.408-.656 2.672-2.72 4.608-.944.88-1.632 1.392-2.224 1.792v.032c1.008-.032 2.32-.048 3.312-.048h1.872V256h-7.616v-1.856c3.584-2.912 5.024-4.432 5.024-6.032 0-1.216-.88-1.712-2-1.712-.816 0-1.68.24-2.576.752Z"
        />
        <circle class="iconCircle iconCircle--4" cx="1008.5" cy="106" r="36" fill="#fff" />
        <path class="linePoint linePoint--4" stroke="#00358e" stroke-width="2" d="M1008.5 234v-92" />
        <circle class="pointCircle pointCircle--4" cx="1008.5" cy="250" r="16" fill="#00358e" />
        <path
          class="pointNumber pointNumber--4"
          fill="#fff"
          d="M1011.37 244.832v7.184h1.52v1.696h-1.52V256h-2.13v-2.288h-5.17v-1.792l4.58-7.088h2.72Zm-2.08 7.184v-1.888c0-.944.01-2.4.06-3.648h-.03c-.42.816-1.2 2.144-1.59 2.752l-1.72 2.784h3.28Z"
        />
        <path
          mask="url(#mask)"
          class="line"
          stroke="#00358e"
          stroke-dasharray="11 11"
          stroke-linecap="round"
          stroke-miterlimit="6.7"
          stroke-width="2"
          stroke-dashoffset="1626.05"
          d="M4.02848 133.98C4.02848 140.98 3.79857 148.04 4.73823 155C10.7761 199.8 46.7332 234.72 96.4654 236.96H195.63C249.071 235.43 289.266 197.72 289.266 146.63L289.186 125.35C289.186 74.85 331.971 33.61 384.542 31.03H480.038C532.569 33.65 574.314 74.88 574.314 125.35L574.344 146.63C574.344 197.54 616.819 235.23 670 237.01L763.387 236.99C816.298 234.97 858.483 197.36 858.483 146.63V125.35C858.492 74.69 900.547 33.35 953.359 31.01L1046.85 31.06C1099.15 33.92 1140.62 75.04 1140.62 125.35"
        />
        <path class="lineStart" d="M3.99857 136C6.20692 136 7.99714 134.209 7.99714 132C7.99714 129.791 6.20692 128 3.99857 128C1.79022 128 0 129.791 0 132C0 134.209 1.79022 136 3.99857 136Z" fill="#00358e"/>
        <path class="lineEnd" d="M1140.24 128.92L1145 120.67H1135.48L1140.24 128.92Z" fill="#00358e"/>
        ${renderIcons(icons, layout)}
      </svg>`,
  }[layout];
}

function fivePointInfographic(icons: string[], layout: Layout): string {
  return {
    small: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" height="400" viewBox="0 0 121 400" aria-hidden="true">
        <defs>
          <mask id="mask" maskUnits="userSpaceOnUse">
            <path
              class="lineMask"
              stroke="#00358e"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="2"
              stroke-dashoffset="660.40"
              stroke-dasharray="660.40"
              d="M40.5 2.15044C40.5 2.15044 49.5 1.59044 56.63 2.59044C74.12 6.64044 87.16 23.3204 87.16 42.0504C87.16 63.8504 71.49 81.5204 49.69 81.5204L38.47 81.4904C16.67 81.4904 1 98.1604 1 119.96C1 141.76 16.67 160.44 38.47 160.45H49.69C71.49 160.45 87.16 178.12 87.16 199.92C87.16 221.72 71.49 239.39 49.69 239.39H38.47C16.67 239.39 1 256.06 1 277.86C1 299.66 16.67 317.33 38.47 317.33L49.69 317.31C71.49 317.31 87.16 334.98 87.16 356.78C87.16 378.58 71.49 396.25 49.69 396.25"
            />
          </mask>
        </defs>
        <g transform="matrix(0 -1 -1 0 121 53)">
          <circle class="pointCircle pointCircle--1" cx="12" cy="12" r="12" fill="#00358e" />
        </g>
        <path class="linePoint linePoint--1" stroke="#00358e" stroke-width="2" d="M97 41H57" />
        <path
          class="pointNumber pointNumber--1"
          fill="#fff"
          d="M110.382 36.624V45h-1.704v-4.38c0-.708.024-1.848.048-2.292h-.024a15.46 15.46 0 0 1-1.02.876l-.432.348-.828-1.128 2.436-1.8h1.524Z"
        />
        <circle class="iconCircle iconCircle--1" cx="41" cy="41" r="16" fill="#fff" />
        <g transform="matrix(0 -1 -1 0 121 132)">
          <circle class="pointCircle pointCircle--2" cx="12" cy="12" r="12" fill="#00358e" />
        </g>
        <path class="linePoint linePoint--2" stroke="#00358e" stroke-width="2" d="M97 120H57" />
        <path
          class="pointNumber pointNumber--2"
          fill="#fff"
          d="m106.41 117.364-.168-1.392c.672-.312 1.572-.492 2.496-.492 1.548 0 2.868.78 2.868 2.424 0 1.056-.492 2.004-2.04 3.456a13.055 13.055 0 0 1-1.668 1.344v.024c.756-.024 1.74-.036 2.484-.036h1.404V124h-5.712v-1.392c2.688-2.184 3.768-3.324 3.768-4.524 0-.912-.66-1.284-1.5-1.284-.612 0-1.26.18-1.932.564Z"
        />
        <circle class="iconCircle iconCircle--2" cx="41" cy="120" r="16" fill="#fff" />
        <g transform="matrix(0 -1 -1 0 121 211)">
          <circle class="pointCircle pointCircle--3" cx="12" cy="12" r="12" fill="#00358e" />
        </g>
        <path class="linePoint linePoint--3" stroke="#00358e" stroke-width="2" d="M97 199H57" />
        <path
          class="pointNumber pointNumber--3"
          fill="#fff"
          d="M107.754 199.304a5.5 5.5 0 0 0-.42.012v-1.248c.132.012.276.024.408.024 1.416 0 2.22-.372 2.22-1.2 0-.744-.648-1.152-1.608-1.152-.672 0-1.344.144-1.932.42l-.108-1.32c.696-.264 1.536-.36 2.28-.36 1.884 0 3.024.816 3.024 2.184 0 1.116-.792 1.788-1.992 1.944v.036c1.26.132 2.1.912 2.1 2.052 0 1.512-1.428 2.448-3.456 2.448a7.306 7.306 0 0 1-2.196-.312l.084-1.404c.732.288 1.38.432 2.028.432 1.056 0 1.836-.384 1.836-1.284s-.828-1.272-2.268-1.272Z"
        />
        <circle class="iconCircle iconCircle--3" cx="41" cy="199" r="16" fill="#fff" />
        <g transform="matrix(0 -1 -1 0 121 290)">
          <circle class="pointCircle pointCircle--4" cx="12" cy="12" r="12" fill="#00358e" />
        </g>
        <path class="linePoint linePoint--4" stroke="#00358e" stroke-width="2" d="M97 278H57" />
        <path
          class="pointNumber pointNumber--4"
          fill="#fff"
          d="M111.15 273.624v5.388h1.14v1.272h-1.14V282h-1.596v-1.716h-3.876v-1.344l3.432-5.316h2.04Zm-1.56 5.388v-1.416c0-.708.012-1.8.048-2.736h-.024c-.312.612-.9 1.608-1.188 2.064l-1.296 2.088h2.46Z"
        />
        <circle class="iconCircle iconCircle--4" cx="41" cy="278" r="16" fill="#fff" />
        <g transform="matrix(0 -1 -1 0 121 369)">
          <circle class="pointCircle pointCircle--5" cx="12" cy="12" r="12" fill="#00358e" />
        </g>
        <path class="linePoint linePoint--5" stroke="#00358e" stroke-width="2" d="M97 357H57" />
        <path
          class="pointNumber pointNumber--5"
          fill="#fff"
          d="M111.522 352.624v1.26h-3.504l-.048 1.836c.348-.072.576-.084.924-.084 1.74 0 2.928.996 2.928 2.604 0 1.788-1.356 2.904-3.48 2.904a7.308 7.308 0 0 1-1.932-.252l.024-1.416a4.41 4.41 0 0 0 1.776.372c1.152 0 1.932-.516 1.932-1.5 0-1.02-.732-1.512-2.004-1.512-.54 0-1.092.096-1.644.276l.06-4.488h4.968Z"
        />
        <circle class="iconCircle iconCircle--5" cx="41" cy="357" r="16" fill="#fff" />
        <path
          class="line"
          mask="url(#mask)"
          stroke="#00358e"
          stroke-dasharray="8 8"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-width="2"
          stroke-dashoffset="660.40"
          d="M40.5 2.15044C40.5 2.15044 49.5 1.59044 56.63 2.59044C74.12 6.64044 87.16 23.3204 87.16 42.0504C87.16 63.8504 71.49 81.5204 49.69 81.5204L38.47 81.4904C16.67 81.4904 1 98.1604 1 119.96C1 141.76 16.67 160.44 38.47 160.45H49.69C71.49 160.45 87.16 178.12 87.16 199.92C87.16 221.72 71.49 239.39 49.69 239.39H38.47C16.67 239.39 1 256.06 1 277.86C1 299.66 16.67 317.33 38.47 317.33L49.69 317.31C71.49 317.31 87.16 334.98 87.16 356.78C87.16 378.58 71.49 396.25 49.69 396.25"
        />
        <path class="lineEnd" d="M44 396L49.25 399.03V392.97L44 396Z" fill="#00358e"/>
        <path class="lineStart" d="M39.0801 4C40.1846 4 41.0801 3.10457 41.0801 2C41.0801 0.89543 40.1846 0 39.0801 0C37.9755 0 37.0801 0.89543 37.0801 2C37.0801 3.10457 37.9755 4 39.0801 4Z" fill="#00358e"/>
        ${renderIcons(icons, layout)}
      </svg>`,
    large: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 1146 266" aria-hidden="true">
        <defs>
          <mask id="mask" maskUnits="userSpaceOnUse">
            <path
              class="lineMask"
              stroke="#00358e"
              stroke-linecap="round"
              stroke-miterlimit="6.7"
              stroke-width="2"
              stroke-dashoffset="1752.1"
              stroke-dasharray="1752.1"
              d="M4.0192 133.98C4.0192 140.98 3.78925 148.04 4.70905 155C10.6077 199.8 47.6493 234.72 96.1883 236.96H138.939C191.107 235.43 231.308 197.72 231.308 146.63L231.228 125.35C231.228 74.85 272.008 33.61 323.317 31.03H366.577C417.855 33.65 459.596 74.88 459.596 125.35L459.626 146.63C459.626 197.54 500.087 235.23 551.985 237.01L593.185 236.99C644.834 234.97 686.004 197.36 686.004 146.63V125.35C686.014 74.69 727.065 33.35 778.603 31.01L821.863 31.06C872.902 33.92 914.392 75.04 914.392 125.35L914.352 146.63C914.352 197.39 954.563 235.01 1006.25 236.99L1048.48 236.96C1099.87 234.68 1140.73 197.17 1140.73 146.63"
            />
          </mask>
        </defs>
        <path class="linePoint linePoint--1" stroke="#00358e" stroke-width="2" d="M115.5 32v92" />
        <circle class="pointCircle pointCircle--1" cx="115.5" cy="16" r="16" fill="#00358e" />
        <path
          class="pointNumber pointNumber--1"
          fill="#fff"
          d="M117.342 10.832V22h-2.272v-5.84c0-.944.032-2.464.064-3.056h-.032c-.256.256-.784.704-1.36 1.168l-.576.464-1.104-1.504 3.248-2.4h2.032Z"
        />
        <circle class="iconCircle iconCircle--1" cx="115.5" cy="160" r="36" fill="#fff" />
        <path class="linePoint linePoint--3" stroke="#00358e" stroke-width="2" d="M572 32v92" />
        <circle class="pointCircle pointCircle--3" cx="572" cy="16" r="16" fill="#00358e" />
        <path
          class="pointNumber pointNumber--3"
          fill="#fff"
          d="M570.338 17.072c-.128 0-.368 0-.56.016v-1.664a6.2 6.2 0 0 0 .544.032c1.888 0 2.96-.496 2.96-1.6 0-.992-.864-1.536-2.144-1.536-.896 0-1.792.192-2.576.56l-.144-1.76c.928-.352 2.048-.48 3.04-.48 2.512 0 4.032 1.088 4.032 2.912 0 1.488-1.056 2.384-2.656 2.592v.048c1.68.176 2.8 1.216 2.8 2.736 0 2.016-1.904 3.264-4.608 3.264-.976 0-1.952-.112-2.928-.416l.112-1.872c.976.384 1.84.576 2.704.576 1.408 0 2.448-.512 2.448-1.712s-1.104-1.696-3.024-1.696Z"
        />
        <circle class="iconCircle iconCircle--3" cx="572" cy="160" r="36" fill="#fff" />
        <path class="linePoint linePoint--5" stroke="#00358e" stroke-width="2" d="M1025.5 32v92" />
        <circle class="pointCircle pointCircle--5" cx="1025.5" cy="16" r="16" fill="#00358e" />
        <path
          class="pointNumber pointNumber--5"
          fill="#fff"
          d="M1028.86 10.832v1.68h-4.67l-.06 2.448c.46-.096.76-.112 1.23-.112 2.32 0 3.9 1.328 3.9 3.472 0 2.384-1.81 3.872-4.64 3.872-.83 0-1.69-.096-2.57-.336l.03-1.888a5.86 5.86 0 0 0 2.37.496c1.53 0 2.57-.688 2.57-2 0-1.36-.97-2.016-2.67-2.016-.72 0-1.46.128-2.19.368l.08-5.984h6.62Z"
        />
        <circle class="iconCircle iconCircle--5" cx="1025.5" cy="160" r="36" fill="#fff" />
        <circle class="iconCircle iconCircle--2" cx="343" cy="106" r="36" fill="#fff" />
        <path class="linePoint linePoint--2" stroke="#00358e" stroke-width="2" d="M343 234v-92" />
        <circle class="pointCircle pointCircle--2" cx="343" cy="250" r="16" fill="#00358e" />
        <path
          class="pointNumber pointNumber--2"
          fill="#fff"
          d="m339.546 247.152-.224-1.856c.896-.416 2.096-.656 3.328-.656 2.064 0 3.824 1.04 3.824 3.232 0 1.408-.656 2.672-2.72 4.608-.944.88-1.632 1.392-2.224 1.792v.032c1.008-.032 2.32-.048 3.312-.048h1.872V256h-7.616v-1.856c3.584-2.912 5.024-4.432 5.024-6.032 0-1.216-.88-1.712-2-1.712-.816 0-1.68.24-2.576.752Z"
        />
        <circle class="iconCircle iconCircle--4" cx="799.5" cy="106" r="36" fill="#fff" />
        <path class="linePoint linePoint--4" stroke="#00358e" stroke-width="2" d="M799.5 234v-92" />
        <circle class="pointCircle pointCircle--4" cx="799.5" cy="250" r="16" fill="#00358e" />
        <path
          class="pointNumber pointNumber--4"
          fill="#fff"
          d="M802.366 244.832v7.184h1.52v1.696h-1.52V256h-2.128v-2.288h-5.168v-1.792l4.576-7.088h2.72Zm-2.08 7.184v-1.888c0-.944.016-2.4.064-3.648h-.032c-.416.816-1.2 2.144-1.584 2.752l-1.728 2.784h3.28Z"
        />
        <path
          mask="url(#mask)"
          class="line"
          stroke="#00358e"
          stroke-dasharray="11 11"
          stroke-linecap="round"
          stroke-miterlimit="6.7"
          stroke-width="2"
          stroke-dashoffset="1752.1"
          d="M4.0192 133.98C4.0192 140.98 3.78925 148.04 4.70905 155C10.6077 199.8 47.6493 234.72 96.1883 236.96H138.939C191.107 235.43 231.308 197.72 231.308 146.63L231.228 125.35C231.228 74.85 272.008 33.61 323.317 31.03H366.577C417.855 33.65 459.596 74.88 459.596 125.35L459.626 146.63C459.626 197.54 500.087 235.23 551.985 237.01L593.185 236.99C644.834 234.97 686.004 197.36 686.004 146.63V125.35C686.014 74.69 727.065 33.35 778.603 31.01L821.863 31.06C872.902 33.92 914.392 75.04 914.392 125.35L914.352 146.63C914.352 197.39 954.563 235.01 1006.25 236.99L1048.48 236.96C1099.87 234.68 1140.73 197.17 1140.73 146.63"
        />
        <path class="lineEnd" d="M1140.24 138L1145 146.25H1135.48L1140.24 138Z" fill="#00358e"/>
        <path class="lineStart" d="M3.99909 136C6.20773 136 7.99818 134.209 7.99818 132C7.99818 129.791 6.20773 128 3.99909 128C1.79045 128 0 129.791 0 132C0 134.209 1.79045 136 3.99909 136Z" fill="#00358e"/>
        ${renderIcons(icons, layout)}
      </svg>`,
  }[layout];
}

function sixPointInfographic(icons: string[], layout: Layout): string {
  return {
    small: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" height="478" viewBox="0 0 121 478" aria-hidden="true">
        <defs>
          <mask id="mask" maskUnits="userSpaceOnUse">
            <path
              class="lineMask"
              stroke="#00358e"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="2"
              stroke-dashoffset="799.73"
              stroke-dasharray="799.73"
              d="M40.5 2.154s9-.556 16.13.444c17.49 4.05 30.53 19.73 30.53 38.46 0 21.8-15.67 40.47-37.47 40.47l-11.22-.03c-21.8 0-37.47 17.67-37.47 39.47 0 21.8 15.67 39.48 37.47 39.49h11.22c21.8 0 37.47 16.67 37.47 38.47 0 21.8-15.67 39.47-37.47 39.47H38.47c-21.8 0-37.47 17.67-37.47 39.47 0 21.8 15.67 39.47 37.47 39.47l11.22-.02c21.8 0 37.47 17.67 37.47 39.47 0 21.8-15.67 39.47-37.47 39.47H38.47c-21.8 0-37.47 17.67-37.47 39.47 0 18.5 12.72 34.03 29.9 38.31 7.6 1.06 15.1.56 15.1.56"
            />
          </mask>
        </defs>
        <g transform="matrix(0 -1 -1 0 121 51.5)">
          <circle class="pointCircle pointCircle--1" cx="12" cy="12" r="12" fill="#00358e" />
        </g>
        <path class="linePoint linePoint--1" stroke="#00358e" stroke-width="2" d="M97 39.5H57" />
        <path
          class="pointNumber pointNumber--1"
          fill="#fff"
          d="M110.382 35.124V43.5h-1.704v-4.38c0-.708.024-1.848.048-2.292h-.024a15.46 15.46 0 0 1-1.02.876l-.432.348-.828-1.128 2.436-1.8h1.524Z"
        />
        <circle class="iconCircle iconCircle--1" cx="41" cy="39.5" r="16" fill="#fff" />
        <g transform="matrix(0 -1 -1 0 121 130.5)">
          <circle class="pointCircle pointCircle--2" cx="12" cy="12" r="12" fill="#00358e" />
        </g>
        <path class="linePoint linePoint--2" stroke="#00358e" stroke-width="2" d="M97 118.5H57" />
        <path
          class="pointNumber pointNumber--2"
          fill="#fff"
          d="m106.41 115.864-.168-1.392c.672-.312 1.572-.492 2.496-.492 1.548 0 2.868.78 2.868 2.424 0 1.056-.492 2.004-2.04 3.456a13.055 13.055 0 0 1-1.668 1.344v.024c.756-.024 1.74-.036 2.484-.036h1.404v1.308h-5.712v-1.392c2.688-2.184 3.768-3.324 3.768-4.524 0-.912-.66-1.284-1.5-1.284-.612 0-1.26.18-1.932.564Z"
        />
        <circle class="iconCircle iconCircle--2" cx="41" cy="118.5" r="16" fill="#fff" />
        <g transform="matrix(0 -1 -1 0 121 209.5)">
          <circle class="pointCircle pointCircle--3" cx="12" cy="12" r="12" fill="#00358e" />
        </g>
        <path class="linePoint linePoint--3" stroke="#00358e" stroke-width="2" d="M97 197.5H57" />
        <path
          class="pointNumber pointNumber--3"
          fill="#fff"
          d="M107.754 197.804a5.5 5.5 0 0 0-.42.012v-1.248c.132.012.276.024.408.024 1.416 0 2.22-.372 2.22-1.2 0-.744-.648-1.152-1.608-1.152-.672 0-1.344.144-1.932.42l-.108-1.32c.696-.264 1.536-.36 2.28-.36 1.884 0 3.024.816 3.024 2.184 0 1.116-.792 1.788-1.992 1.944v.036c1.26.132 2.1.912 2.1 2.052 0 1.512-1.428 2.448-3.456 2.448a7.306 7.306 0 0 1-2.196-.312l.084-1.404c.732.288 1.38.432 2.028.432 1.056 0 1.836-.384 1.836-1.284s-.828-1.272-2.268-1.272Z"
        />
        <circle class="iconCircle iconCircle--3" cx="41" cy="197.5" r="16" fill="#fff" />
        <g transform="matrix(0 -1 -1 0 121 288.5)">
          <circle class="pointCircle pointCircle--4" cx="12" cy="12" r="12" fill="#00358e" />
        </g>
        <path class="linePoint linePoint--4" stroke="#00358e" stroke-width="2" d="M97 276.5H57" />
        <path
          class="pointNumber pointNumber--4"
          fill="#fff"
          d="M111.15 272.124v5.388h1.14v1.272h-1.14v1.716h-1.596v-1.716h-3.876v-1.344l3.432-5.316h2.04Zm-1.56 5.388v-1.416c0-.708.012-1.8.048-2.736h-.024c-.312.612-.9 1.608-1.188 2.064l-1.296 2.088h2.46Z"
        />
        <circle class="iconCircle iconCircle--4" cx="41" cy="276.5" r="16" fill="#fff" />
        <g transform="matrix(0 -1 -1 0 121 367.5)">
          <circle class="pointCircle pointCircle--5" cx="12" cy="12" r="12" fill="#00358e" />
        </g>
        <path class="linePoint linePoint--5" stroke="#00358e" stroke-width="2" d="M97 355.5H57" />
        <path
          class="pointNumber pointNumber--5"
          fill="#fff"
          d="M111.522 351.124v1.26h-3.504l-.048 1.836c.348-.072.576-.084.924-.084 1.74 0 2.928.996 2.928 2.604 0 1.788-1.356 2.904-3.48 2.904a7.308 7.308 0 0 1-1.932-.252l.024-1.416a4.41 4.41 0 0 0 1.776.372c1.152 0 1.932-.516 1.932-1.5 0-1.02-.732-1.512-2.004-1.512-.54 0-1.092.096-1.644.276l.06-4.488h4.968Z"
        />
        <circle class="iconCircle iconCircle--5" cx="41" cy="355.5" r="16" fill="#fff" />
        <g transform="matrix(0 -1 -1 0 121 446.5)">
          <circle class="pointCircle pointCircle--6" cx="12" cy="12" r="12" fill="#00358e" />
        </g>
        <path class="linePoint linePoint--6" stroke="#00358e" stroke-width="2" d="M97 434.5H57" />
        <path
          class="pointNumber pointNumber--6"
          fill="#fff"
          d="m111.57 430.244-.168 1.32a3.894 3.894 0 0 0-1.548-.324c-1.404 0-2.244 1.008-2.28 2.76h.024c.42-.564 1.176-.912 1.944-.912 1.596 0 2.592 1.068 2.592 2.664 0 1.668-1.164 2.892-3.072 2.892-2.052 0-3.108-1.428-3.108-4.044 0-2.964 1.44-4.62 3.816-4.62.636 0 1.296.084 1.8.264Zm-2.376 4.044c-.756 0-1.488.684-1.488 1.524 0 .936.6 1.656 1.416 1.656.912 0 1.38-.732 1.38-1.596 0-.9-.36-1.584-1.308-1.584Z"
        />
        <circle class="iconCircle iconCircle--6" cx="41" cy="434.5" r="16" fill="#fff" />
        <path
          class="line"
          mask="url(#mask)"
          stroke="#00358e"
          stroke-dasharray="8 8"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-width="2"
          stroke-dashoffset="799.73"
          d="M40.5 2.154s9-.556 16.13.444c17.49 4.05 30.53 19.73 30.53 38.46 0 21.8-15.67 40.47-37.47 40.47l-11.22-.03c-21.8 0-37.47 17.67-37.47 39.47 0 21.8 15.67 39.48 37.47 39.49h11.22c21.8 0 37.47 16.67 37.47 38.47 0 21.8-15.67 39.47-37.47 39.47H38.47c-21.8 0-37.47 17.67-37.47 39.47 0 21.8 15.67 39.47 37.47 39.47l11.22-.02c21.8 0 37.47 17.67 37.47 39.47 0 21.8-15.67 39.47-37.47 39.47H38.47c-21.8 0-37.47 17.67-37.47 39.47 0 18.5 12.72 34.03 29.9 38.31 7.6 1.06 15.1.56 15.1.56"
        />
        <circle class="lineStart" cx="38.16" cy="2" r="2" fill="#00358e" />
        <path class="lineEnd" fill="#00358e" d="m52 474.216-5.25 3.031v-6.062l5.25 3.031Z" />
        ${renderIcons(icons, layout)}
      </svg>`,
    large: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 1142 266" aria-hidden="true">
        <defs>
          <mask id="mask" maskUnits="userSpaceOnUse">
            <path
              class="lineMask"
              stroke="#00358e"
              stroke-linecap="round"
              stroke-miterlimit="6.7"
              stroke-width="2"
              stroke-dashoffset="1902.16"
              stroke-dasharray="1902.16"
              d="M4.024 133c0 6.996-.22 14.046.67 21 5.917 46.274 44.142 82 93.61 82 52.12 0 94.37-38.25 94.37-90.37l-.08-21.26c0-52.12 42.25-94.37 94.37-94.37 52.12 0 94.37 42.25 94.37 94.37l.03 21.26c0 52.12 42.25 90.37 94.37 90.37 52.12 0 94.37-38.25 94.37-90.37l.01-21.26c0-52.12 42.25-94.37 94.37-94.37 52.12 0 94.37 42.25 94.37 94.37l-.04 21.26c0 52.12 42.25 90.37 94.37 90.37 52.12 0 95.37-38.25 95.37-90.37l-.01-21.26c0-52.12 41.25-94.37 93.366-94.37 52.12 0 94.37 43.25 94.37 95.37v20.26"
            />
          </mask>
        </defs>
        <path class="linePoint linePoint--1" stroke="#00358e" stroke-width="2" d="M102.5 32v92" />
        <circle class="pointCircle pointCircle--1" cx="102.5" cy="16" r="16" fill="#00358e" />
        <path
          class="pointNumber pointNumber--1"
          fill="#fff"
          d="M104.342 10.832V22h-2.272v-5.84c0-.944.032-2.464.064-3.056h-.032c-.256.256-.784.704-1.36 1.168l-.576.464-1.104-1.504 3.248-2.4h2.032Z"
        />
        <circle class="iconCircle iconCircle--1" cx="102.5" cy="160" r="36" fill="#fff" />
        <path class="linePoint linePoint--3" stroke="#00358e" stroke-width="2" d="M481 32v92" />
        <circle class="pointCircle pointCircle--3" cx="481" cy="16" r="16" fill="#00358e" />
        <path
          class="pointNumber pointNumber--3"
          fill="#fff"
          d="M479.338 17.072c-.128 0-.368 0-.56.016v-1.664a6.2 6.2 0 0 0 .544.032c1.888 0 2.96-.496 2.96-1.6 0-.992-.864-1.536-2.144-1.536-.896 0-1.792.192-2.576.56l-.144-1.76c.928-.352 2.048-.48 3.04-.48 2.512 0 4.032 1.088 4.032 2.912 0 1.488-1.056 2.384-2.656 2.592v.048c1.68.176 2.8 1.216 2.8 2.736 0 2.016-1.904 3.264-4.608 3.264-.976 0-1.952-.112-2.928-.416l.112-1.872c.976.384 1.84.576 2.704.576 1.408 0 2.448-.512 2.448-1.712s-1.104-1.696-3.024-1.696Z"
        />
        <circle class="iconCircle iconCircle--3" cx="481" cy="160" r="36" fill="#fff" />
        <path class="linePoint linePoint--5" stroke="#00358e" stroke-width="2" d="M859.5 32v92" />
        <circle class="pointCircle pointCircle--5" cx="859.5" cy="16" r="16" fill="#00358e" />
        <path
          class="pointNumber pointNumber--5"
          fill="#fff"
          d="M862.862 10.832v1.68h-4.672l-.064 2.448a5.353 5.353 0 0 1 1.232-.112c2.32 0 3.904 1.328 3.904 3.472 0 2.384-1.808 3.872-4.64 3.872a9.744 9.744 0 0 1-2.576-.336l.032-1.888a5.88 5.88 0 0 0 2.368.496c1.536 0 2.576-.688 2.576-2 0-1.36-.976-2.016-2.672-2.016-.72 0-1.456.128-2.192.368l.08-5.984h6.624Z"
        />
        <circle class="iconCircle iconCircle--5" cx="859.5" cy="160" r="36" fill="#fff" />
        <circle class="iconCircle iconCircle--2" cx="290.5" cy="106" r="36" fill="#fff" />
        <path class="linePoint linePoint--2" stroke="#00358e" stroke-width="2" d="M290.5 234v-92" />
        <circle class="pointCircle pointCircle--2" cx="290.5" cy="250" r="16" fill="#00358e" />
        <path
          class="pointNumber pointNumber--2"
          fill="#fff"
          d="m287.046 247.152-.224-1.856c.896-.416 2.096-.656 3.328-.656 2.064 0 3.824 1.04 3.824 3.232 0 1.408-.656 2.672-2.72 4.608-.944.88-1.632 1.392-2.224 1.792v.032c1.008-.032 2.32-.048 3.312-.048h1.872V256h-7.616v-1.856c3.584-2.912 5.024-4.432 5.024-6.032 0-1.216-.88-1.712-2-1.712-.816 0-1.68.24-2.576.752Z"
        />
        <circle class="iconCircle iconCircle--4" cx="668" cy="106" r="36" fill="#fff" />
        <path class="linePoint linePoint--4" stroke="#00358e" stroke-width="2" d="M668 234v-92" />
        <circle class="pointCircle pointCircle--4" cx="668" cy="250" r="16" fill="#00358e" />
        <path
          class="pointNumber pointNumber--4"
          fill="#fff"
          d="M670.866 244.832v7.184h1.52v1.696h-1.52V256h-2.128v-2.288h-5.168v-1.792l4.576-7.088h2.72Zm-2.08 7.184v-1.888c0-.944.016-2.4.064-3.648h-.032c-.416.816-1.2 2.144-1.584 2.752l-1.728 2.784h3.28Z"
        />
        <circle class="iconCircle iconCircle--6" cx="1045.5" cy="106" r="36" fill="#fff" />
        <path class="linePoint linePoint--6" stroke="#00358e" stroke-width="2" d="M1045.5 234v-92" />
        <circle class="pointCircle pointCircle--6" cx="1045.5" cy="250" r="16" fill="#00358e" />
        <path
          class="pointNumber pointNumber--6"
          fill="#fff"
          d="m1048.93 244.992-.23 1.76a5.18 5.18 0 0 0-2.06-.432c-1.87 0-2.99 1.344-3.04 3.68h.03c.56-.752 1.57-1.216 2.59-1.216 2.13 0 3.46 1.424 3.46 3.552 0 2.224-1.55 3.856-4.1 3.856-2.73 0-4.14-1.904-4.14-5.392 0-3.952 1.92-6.16 5.09-6.16.84 0 1.72.112 2.4.352Zm-3.17 5.392c-1.01 0-1.99.912-1.99 2.032 0 1.248.8 2.208 1.89 2.208 1.22 0 1.84-.976 1.84-2.128 0-1.2-.48-2.112-1.74-2.112Z"
        />
        <path
          mask="url(#mask)"
          class="line"
          stroke="#00358e"
          stroke-dasharray="11 11"
          stroke-linecap="round"
          stroke-miterlimit="6.7"
          stroke-width="2"
          stroke-dashoffset="1902.16"
          d="M4.024 133c0 6.996-.22 14.046.67 21 5.917 46.274 44.142 82 93.61 82 52.12 0 94.37-38.25 94.37-90.37l-.08-21.26c0-52.12 42.25-94.37 94.37-94.37 52.12 0 94.37 42.25 94.37 94.37l.03 21.26c0 52.12 42.25 90.37 94.37 90.37 52.12 0 94.37-38.25 94.37-90.37l.01-21.26c0-52.12 42.25-94.37 94.37-94.37 52.12 0 94.37 42.25 94.37 94.37l-.04 21.26c0 52.12 42.25 90.37 94.37 90.37 52.12 0 95.37-38.25 95.37-90.37l-.01-21.26c0-52.12 41.25-94.37 93.366-94.37 52.12 0 94.37 43.25 94.37 95.37v20.26"
        />
        <circle class="lineStart" cx="4" cy="133" r="4" fill="#00358e" />
        <path class="lineEnd" fill="#00358e" d="m1136.5 153-4.76-8.25h9.52l-4.76 8.25Z" />
        ${renderIcons(icons, layout)}
      </svg>`,
  }[layout];
}

function renderIcons(icons: string[], layout: Layout): string {
  const updatedIcons = addCoordinatesToIcons(icons, layout);
  return `<g class="iconContainer">${updatedIcons.join('')}</g>`;
}

export function renderInfographic(points: valueChainPoint[], icons: string[], layout: Layout): JSX.Element {
  // svg has to be a string because innerHTML is not working for svg in JSX
  const infographic =
    {
      3: threePointInfographic(icons, layout),
      4: fourPointInfographic(icons, layout),
      5: fivePointInfographic(icons, layout),
      6: sixPointInfographic(icons, layout),
    }[points.length] || threePointInfographic(icons, layout);
  return <div innerHTML={infographic}></div>;
}
